// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3kJp0","productName":"Table_productName__1yYPg"};